import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { ProjectFinancialSummary } from '../generated/types';

export const PROJECT_FINANCIAL_SUMMARY_QUERY = gql`
  query ProjectFinancialSummary($projectId: ID!) {
    projectFinancialSummary(projectId: $projectId) {
      totalContractsValue
      totalPaid
      totalPending
      totalOverdue
      balance
    }
  }
`;

export function useProjectFinancialSummary(projectId: string) {
  const { data, loading, error, refetch } = useQuery<{ projectFinancialSummary: ProjectFinancialSummary }>(PROJECT_FINANCIAL_SUMMARY_QUERY, {
    variables: { projectId },
  });

  const summary: ProjectFinancialSummary | null = data?.projectFinancialSummary ?? null;

  return { summary, loading, error, refetch };
}
